export const URLS = {
  TRANSACTIONS: 'Transactions/filter',
  VDA: 'OurUrls like api/private/user[id]',
  LOGIN: 'users/login',
  MY_ACCOUNTS: 'accounts/myAccounts',
  TEXT_BOX_FILTER: 'transactions/filter',
  PRE_COLORGATE: 'SKUCatalog/pre-colorgate',
  POST_COLORGATE: 'SKUCatalog/post-colorgate',
  SKU_DOWNLOAD_BOM_FILES: 'SKUCatalog/download-bom-files',
  AUDIT: 'Audit/filter',
  ARTWORKS: 'artworks',
  EMPTY_ARTWORKS: 'artworks/emptyArtwork',
  ARTWORKS_UPDATE: 'artworks/update',
  ARTWORKS_CRATE: '/artworks/create',
  ARTWORKS_BULK_IMPORT: 'artworks/import',
  ARTWORKS_FILTER: 'artworks/filter',
  ARTWORKS_SELECT_ALL: 'artworks/select/all',
  BLANKS_SELECT_ALL: 'blanks/select/all',
  TRIM_FILTER: 'trims/filter',
  STAMPS_FILTER: 'stamps/filter',
  BLANKS: 'blanks/filter',
  BLANKS_MANAGEMENT: 'blanksManagement/blanksManagement',
  BOM_IMPORT: '/bom/import',
  BOM_FILE_EXPORT: 'bom/file/export',
  ORDER_IMPORT: '/orders/import',
  ORDER_CONTINUE_IMPORT: 'Orders/import',
  IMPORT_ERROR: 'ImportErrors/filter',
  ALERTS: '/Notifications/filter',
  ALERTS_DELETE: '/Notifications/delete',
  ALERTS_DELETE_BY_DATE: '/Notifications/deleteByDate',
  TASKS_FILTER: 'tasks/filter',
  TASKS_DELETE: 'tasks/delete',
  ASSIGN_TASKS: 'Tasks/getviewmodel',
  ASSIGN_TASKS_ASSIGN: 'Tasks/assign',
  MOCKUP_COMPARISON: 'prelistings/compare/all',
  MOCKUP_KSF: 'SKUCatalog/get-rip-items-by-correlation',
  MOCKUP_BOM: 'SKUCatalog/get-bom-files-by-correlation',
  MOCKUP_KSF_LOGS: 'ChangeTracker/get-rip-logs',
  MOCKUP_BOM_LOGS: 'ChangeTracker/get-bom-logs',
  ORDERS: 'Orders/filter',
  ORDERS_DASHBOARD: 'OrdersDashboard/filter',
  ARCHIVED_ORDERS_DASHBOARD: 'OrdersArchive/filter',
  ORDERS_DASHBOARD_PRODUCT: 'OrdersDashboard/line-item-product-info',
  ORDERS_DASHBOARD_ORDER: 'OrdersDashboard/line-item-order-info',
  ORDERS_DASHBOARD_EXPORT: 'OrdersDashboard/export',
  ORDERS_DASHBOARD_SAVE_COMMENT: 'OrdersDashboard/saveComment',
  ORDER_ROUTING: 'OrdersRouting/filter',
  ARCHIVED_ORDER_ROUTING: 'OrdersRoutingArchive/filter',
  ORDER_ROUTING_SUBMIT: 'OrdersRouting/submitOrder',
  ORDERS_EXPORT: 'OrdersRouting/export',
  ORDER_ROUTING_ORDER_INFO: 'OrdersRouting/line-item-order-info',
  ORDER_ROUTING_LINE_ITEMS: 'OrdersRouting/filter-items',
  ORDER_ROUTING_SAVE_COMMENT: 'OrdersRouting/saveComment',
  SELECT: (page: string): string => `${page}/select`,
  PRODUCTION_TICKETS: 'OrdersDashboard/line-item-production-tickets',
  LINE_ITEMS_INVENTORY: 'OrdersDashboard/line-item-inventory',
  DOWNLOAD_ALL_TRIM: 'OrdersDashboard/download/archive/trim',
  DOWNLOAD_ASSET: 'OrdersDashboard/download',
  DOWNLOAD_ALL_ORIGINAL: 'OrdersDashboard/download/archive/original',
  DOWNLOAD_ALL_DTG: 'OrdersDashboard/download/archive/dtg',
  DOWNLOAD_DTG: 'OrdersDashboard/download/dtg',
  ORDERS_IMPORT_PARENT_ACCOUNT_NEW: 'orders/importParentAccountNew',
  EXPORT_PRODUCTS: 'export/products',
  EXPORT_PRODUCTS_DOWNLOAD: 'export/download-products',
  EXPORT_PRODUCTS_SEND_CSV: 'export/send-products-csv',
  EXPORT_PRODUCTS_SEND: 'export/send-products',
  DESIGN_STUDIO_MOCKUP_INFORMATION: 'DesignStudio/mockup/information',
  DESIGN_STUDIO_CALCULATE_MOCKUP_REAL_SIZE: 'DesignStudio/calculate-mockup-real-size',
  DESIGN_STUDIO_SAVE: 'DesignStudio/save-mockup',
  PRELISTINGS: 'prelistings',
  PRELISTINGS_PREVIEW: 'prelistings/preview',
  PRELISTINGS_PREVIEW_COMMENTS_ADD: 'prelistings/preview/comments/add',
  PRELISTINGS_PREVIEW_SELECT_COLORS: 'prelistings/selectColors',
  POWER_BI_GENERATE_TOKEN: 'PowerBi/generate-token',
};
